export enum CalendlyTypes {
  OVERVIEW = 'overview',
  CALENDLY = 'calendly'
}
